import React from 'react';
import ComboTotalPage from './components/ComboTotalPage';

function ComboTotalHumberto() {
  return <ComboTotalPage paymentUrlOverride="https://pay.kiwify.com.br/yKYVFMc?afid=jaftypEz" />;
}

export default ComboTotalHumberto;
